import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Styles from './styles';

const AnnotationPopover = ({
  top,
  left,
  annotationContent,
  isVisible,
  annotationId,
  openAnnotation
}) => {
  const target = useRef(null);

  return (
    <Styles.AnnotationIconContainer isVisible={isVisible} ref={target} top={top} left={left}>
      <FontAwesomeIcon icon="map-marker" size="lg" color="var(--primary)" />
      <Overlay target={target} container={target.current} show={isVisible} placement="right">
        <Popover
          key={annotationId}
          id={annotationId}
          content={annotationContent}
          onClick={openAnnotation}
        >
          {annotationContent}
        </Popover>
      </Overlay>
    </Styles.AnnotationIconContainer>
  );
};

AnnotationPopover.defaultProps = {
  top: 0,
  left: 0,
  annotationContent: 'Test Annotation',
  isVisible: false,
  annotationId: ''
};

AnnotationPopover.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  annotationContent: PropTypes.string,
  isVisible: PropTypes.bool,
  annotationId: PropTypes.string,
  openAnnotation: PropTypes.func.isRequired
};

export default AnnotationPopover;
